import { CheckboxGroupField } from "@/components/ui/form/fields/check-box-field/check-box-group";

import { useWeekdaySettings } from "./hooks/use-weekday-settings";
import { PriceInput } from "../_components/price-input";

export const StaticPriceWeekdaySettings = () => {
	const {
		rawAvailableWeekday,
		weekdayPriceFieldOptions,
		onSetWeekendPriceInput,
		capacityPeopleMaximum,
		weekdayPrices,
		canAppendItem,
		appendItem,
		removeItem,
		onSetWeekendUpperNum,
		onSetAvailableWeekday,
	} = useWeekdaySettings();

	return (
		<div className="space-y-6">
			<h5>平日価格にする曜日を設定してください</h5>
			<CheckboxGroupField
				value={rawAvailableWeekday}
				options={weekdayPriceFieldOptions}
				handleCheckedChange={onSetAvailableWeekday}
				gridCols={2}
			/>
			<PriceInput
				prices={weekdayPrices}
				appendItem={appendItem}
				capacityPeopleMaximum={capacityPeopleMaximum}
				canAppendItem={canAppendItem}
				removeItem={removeItem}
				onSetWeekendPriceInput={onSetWeekendPriceInput}
				onSetWeekendUpperNum={onSetWeekendUpperNum}
			/>
		</div>
	);
};
